import { AccountTerritory } from 'domains/account'

import { protectedApi } from './requester'

export const getAccountTerritory = () => {
  return protectedApi.get<AccountTerritory[]>('/territory').then((response) => response.data)
}
